const samples = [];
export function collectCallDiagnostics(session) {
  let timer;
  let stopped = false;
  const collect = async () => {
    const pc = session.sessionDescriptionHandler?.peerConnection;
    try {
      if (pc) {
        const stats = await pc.getStats();
        const sample = { at: new Date().toISOString(), sipCallId: session.request?.callId || session.id, connectionState: pc.connectionState };
        stats.forEach(report => {
          if (report.type === 'inbound-rtp' && report.kind === 'audio') Object.assign(sample, { packetsReceived: report.packetsReceived, packetsLost: report.packetsLost, jitterSeconds: report.jitter });
          if (report.type === 'candidate-pair' && report.state === 'succeeded' && report.nominated) {
            sample.rttSeconds = report.currentRoundTripTime;
            const local = stats.get(report.localCandidateId);
            sample.candidateType = local?.candidateType;
            sample.transport = local?.protocol;
          }
        });
        samples.push(sample);
        if (samples.length > 120) samples.shift();
      }
    } catch (_) { /* Stats must never interrupt audio. */ }
    if (!stopped) timer = setTimeout(collect, 5000);
  };
  session.stateChange.addListener(state => { if (state === 'Terminated') { stopped = true; clearTimeout(timer); } });
  collect();
}
export function downloadPhoneDiagnostics() {
  const url = URL.createObjectURL(new Blob([JSON.stringify({ generatedAt: new Date().toISOString(), samples }, null, 2)], { type: 'application/json' }));
  const anchor = document.createElement('a'); anchor.href = url; anchor.download = 'phone-diagnostics.json'; anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
